import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router, RouterLink, RouterOutlet, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-master',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterOutlet],
  templateUrl: './master.html',
  styleUrl: './master.css',
})
export class Master implements OnInit {
  // Top-bar phone: Mumbai by default, Kolkata on routes flagged with data.city = 'kolkata'
  private readonly mumbaiPhone = { href: 'tel:+916262662662', text: '+91 62-62-66-26-62' };
  private readonly kolkataPhone = { href: 'tel:+916262030303', text: '+91 62-62-03-03-03' };
  topBarPhone = this.mumbaiPhone;
  // Kolkata pages are call / WhatsApp only, so links to the enquiry form page are hidden there
  isKolkata = false;
  // Contact Us page: the footer lists the Kolkata services there
  isContact = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  private updateTopBarPhone(): void {
    const city = this.route.snapshot.firstChild?.data?.['city'];
    this.isKolkata = city === 'kolkata';
    this.isContact = this.route.snapshot.firstChild?.routeConfig?.path === 'contactus';
    this.topBarPhone = this.isKolkata ? this.kolkataPhone : this.mumbaiPhone;
  }

  ngOnInit(): void {
    this.updateTopBarPhone();
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateTopBarPhone();
        // Scroll page to top

         // Don't scroll to top when navigating to an anchor
    if (window.location.hash) {
      return;
    }
    
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    });
  }

isMobileMenuOpen = false;

toggleMenu() {
  this.isMobileMenuOpen = !this.isMobileMenuOpen;
}

}
